import { actionField } from '../../../../topics'

export const hasActionField = ctaType =>
  Object.values(actionField).includes(ctaType)
